import { render, staticRenderFns } from "./RemoveSupplierDialog.vue?vue&type=template&id=5d8a7904"
import script from "./RemoveSupplierDialog.vue?vue&type=script&lang=js"
export * from "./RemoveSupplierDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports